import script from "./LegalDocsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalDocsModal.vue?vue&type=script&setup=true&lang=js"

import "./LegalDocsModal.vue?vue&type=style&index=0&id=265b25b7&scoped=true&lang=css"
import "./LegalDocsModal.vue?vue&type=style&index=1&id=265b25b7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265b25b7"]])

export default __exports__